class AnnouncementBar extends HTMLElement { // eslint-disable-line
  constructor() {
    super()

    this.slider = this.querySelector('[data-announcement-bar]')

    if (!this.slider) { return }

    this.slides = this.slider.querySelectorAll('a, div')
    this.init()
  }

  init() {
    if (this.slides.length <= 1) { return }

    const timer = Number(this.dataset.timer)

    $(this.slider).on('init', () => {
      this.slides.forEach(slide => {
        slide.classList.remove('hidden')
      });
    });

    $(this.slider).slick({
      slidesToShow: 1,
      arrows: false,
      infinite: true,
      fade: true,
      pauseOnHover: true,
      pauseOnFocus: true,
      autoplay: true,
      autoplaySpeed: timer
    });
  }
}

customElements.define('announcement-bar', AnnouncementBar);

